/* ========================================================================
 *
 * Carousel height
 *
 * ======================================================================== */

var Carouselfnc = {};

(function($) {

	Carouselfnc.carouselHeights = function() {
		var carousels = $('.carousel'),
				items = [],
				heights = [],
				tallest = [];

		carousels.each(function() {
			items.push( $(this).find('.item') );
		});

		function debounce(func, wait, immediate) {
    	var timeout;
    	return function() {
    		var context = this, args = arguments;
    		var later = function() {
    			timeout = null;
    			if (!immediate) func.apply(context, args);
    		};

    		var callNow = immediate && !timeout;
    		clearTimeout(timeout);
    		timeout = setTimeout(later, wait);
    		if (callNow) func.apply(context, args);
    	};
    }

		var normalizeHeights = function() {
			for(var i = 0; i < items.length; i++) {
				itemHeight = [];

				items[i].each(function () {
					itemHeight.push($(this).outerHeight());
				});

				heights[i] = itemHeight;

				tallest[i] = Math.max.apply(null, heights[i]); //cache largest value

				items[i].each(function () {
					//add extra padding to vertical align
					var diff = tallest[i] - $(this).outerHeight();
					if(diff > 0) {
						var padding = (diff / 2);
						$('.container', this).css('padding-top', padding + 'px');
					} else {
						$('.container', this).css('padding-top', '0px');
					}

					$(this).css('min-height',tallest[i] + 'px');
				});
			}
		};

		var resizeFn = debounce(function() {
			//reset vars
			tallest.length = 0;
			heights.length = 0;

			for(var i = 0; i < items.length; i++) {
				items[i].each(function () {
					$('.container', this).css('padding-top', '0px'); //reset padding-top
					$(this).css('min-height', '0'); //reset min-height
				});
			}

			normalizeHeights(); //run it again
		}, 300);



		$(window).on('resize orientationchange', resizeFn);

		normalizeHeights(); //run it again

	};

	// Initialize
	setTimeout(function(){ Carouselfnc.carouselHeights(); }, 300);



})(jQuery);
